import { useState } from "react";
import { Input } from "./ui/input";
import { SearchIcon } from "lucide-react";
import { Drawer } from "./ui/custom/Drawer";
import { SearchDrawer } from "./SearchDrawer";
import { useLocationMenus } from "@/hooks/useLocationMenus";
import { menuRoute } from "@/App";
import { Button } from "./ui/button";
import { AiButton } from "./AiAssistant";

function SearchBar() {
  const [searchDrawerIsOpen, setSearchDrawerIsOpen] = useState<boolean>(false);
  const { availableMenus, hasMultipleMenus } = useLocationMenus();
  const { menuId } = menuRoute.useParams();
  const selectedMenu = availableMenus.find((menu) => menu.id === menuId);

  const label = hasMultipleMenus
    ? `Search in ${selectedMenu?.name}`
    : "Search menu...";

  function handleCloseSearch() {
    setSearchDrawerIsOpen(false);
  }
  return (
    <>
      <div className="flex gap-2 w-full">
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            setSearchDrawerIsOpen(true);
          }}
          aria-label={label}
          className="block w-full relative"
        >
          <Input
            type="search"
            placeholder={label}
            className="text-foreground-muted w-full border-none bg-muted rounded-full px-4 h-11 text-[14px] pr-5 text-ellipsis pointer-events-none"
          />
          <SearchIcon
            className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none opacity-50"
            size={14}
          />
        </button>

        <AiButton className="rounded-full bg-primary text-primary-foreground hover:bg-muted hover:text-muted-foreground shadow-none aspect-square" />
      </div>

      <ControlledDrawer
        isOpen={searchDrawerIsOpen}
        handleClose={handleCloseSearch}
      />
    </>
  );
}

export function SearchButton({ onClose }: { onClose?: () => void }) {
  const [searchDrawerIsOpen, setSearchDrawerIsOpen] = useState<boolean>(false);
  const { availableMenus, hasMultipleMenus } = useLocationMenus();
  const { menuId } = menuRoute.useParams();
  const selectedMenu = availableMenus.find((menu) => menu.id === menuId);

  const label = hasMultipleMenus
    ? `Search in ${selectedMenu?.name}`
    : "Search menu";

  return (
    <>
      <Button
        onClick={(event) => {
          event.stopPropagation();
          setSearchDrawerIsOpen(true);
        }}
        size="icon"
        className="h-12 w-12 rounded-lg bg-background hover:bg-background/90 text-foreground shadow-lg transition-all duration-200 hover:scale-110"
      >
        <div className="size-6 flex items-center justify-center rounded-full aspect-square text-xsfont-medium">
          <SearchIcon size={14} />
        </div>
      </Button>

      <span
        className="absolute top-1/2 left-0 translate-x-14 text-left -translate-y-1/2 text-sm  whitespace-nowrap bg-background py-1 px-3 rounded-lg text-foreground"
        onClick={(event) => {
          event.stopPropagation();
          setSearchDrawerIsOpen(true);
        }}
      >
        {label}
      </span>

      <ControlledDrawer
        isOpen={searchDrawerIsOpen}
        handleClose={() => {
          setSearchDrawerIsOpen(false);
          onClose?.();
        }}
      />
    </>
  );
}

function ControlledDrawer({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
}) {
  return (
    <Drawer
      isOpen={isOpen}
      closeDrawer={handleClose}
      classes={{
        root: "!z-[19]",
        paper: "rounded-t-2xl !overflow-visible !bg-transparent",
      }}
    >
      <div className="z-[1]">
        {isOpen && <SearchDrawer />}
      </div>
    </Drawer>
  );
}

export { SearchBar };
